import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, trackPageview } from '../lib/analytics';

const AnalyticsTracker: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageview(window.location.origin + pathname + search);
  }, [pathname, search]);

  return null;
};

export default AnalyticsTracker;
